import React from 'react';
import { Chart } from 'react-google-charts';

export const options = {
  title: 'Cursos finalizados',
  pieHole: 0.4,
  is3D: false,
  backgroundColor: 'transparent',
  titleTextStyle: {
    color: '#FFFFFF',
    fontSize: 20,
  },
  legend: {
    textStyle: { color: '#FFFFFF', fontSize: 14 },
  },
  hAxis: {
    textStyle: { color: '#FFFFFF' },
    titleTextStyle: { color: '#FFFFFF' },
  },
  vAxis: {
    textStyle: { color: '#FFFFFF' },
    titleTextStyle: { color: '#FFFFFF' },
  },
  pieSliceTextStyle: {
    color: '#FFFFFF',
  },
};

export function GoogleDonutChart({ data }) {
  const tData = data &&
    data.length !== 0 && [
      ['Curso', 'Valor'],
      ...data.map((item) => [item.name, parseInt(item.value)]),
    ];
  return (
    tData && (
      <Chart chartType="PieChart" data={tData} options={options} width={'100%'} height={'400px'} />
    )
  );
}
